import React from 'react'
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Slider from 'react-slick';
import Reviews from '../../Reviews';

const images = new Array(10).fill("assets/images/Mask group (1).png");



const CustomersReviews = () => {
    const settings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (

        <Box sx={{height:'450px',overflowY:'hidden'}}>
            
            <Slider {...settings}>
                {images.map((url, index) => (
                    <Box key={index}>
                        <Card
                            variant="outlined"
                            sx={{
                                width:"407px",
                                height:'343px',
                                backgroundColor:'transparent',
                                margin:'20px',
                                
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    margin:'1rem 0'
                                }}
                            >
                                <Avatar src={url} />


                                <Reviews/>
                            </Box>
                            <CardContent>
                                
                                <Typography level="body-sm" sx={{textAlign:'left'}}>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi repudiandae accusantium nostrum exercitationem delectus ab, ratione amet inventore tenetur odit nemo et odio quia neque!
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis labore voluptatem at mollitia quis impedit ea dignissimos blanditiis? Ducimus repellat vitae non dolor consequuntur rem a, qui quasi natus consectetur.
                                    </Typography>
                            </CardContent>

                        </Card>


                    </Box>
                ))}
            </Slider>
        </Box>

    )
}

export default CustomersReviews;